import type { TranslationDict } from './ja'

export const th: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'วิธีเล่น',
  helpAria: 'วิธีเล่น',
  settings: 'ตั้งค่า',
  settingsAria: 'ตั้งค่า',
  close: 'ปิด',
  closeAria: 'ปิด',
  player: 'ผู้เล่น',
  highscore: 'คะแนนสูงสุด',
  start: 'เริ่มเกม',
  staminaEmpty: 'สตามินาไม่พอ',
  ranking: 'ศึกชิงอาณาเขต',
  difficultyTitle: 'เลือกระดับ',
  difficultyStart: 'เริ่มด้วยระดับนี้',
  back: 'กลับ',
  today: 'วันนี้',
  weekly: 'สัปดาห์นี้',
  alltime: 'ทั้งหมด',
  loading: 'กำลังโหลด...',
  noScores: 'ยังไม่มีคะแนน มาเป็นแชมป์คนแรกกัน!',
  loadFailed: 'โหลดไม่สำเร็จ',
  you: 'คุณ',
  youConstant: 'คุณ',
  language: 'ภาษา',
  languageNote: 'รองรับ 18 ภาษา รวมภาษาญี่ปุ่น',
  bgm: 'BGM',
  se: 'เอฟเฟกต์เสียง',
  soundEnableAria: 'เปิดเสียง',
  soundDisableAria: 'ปิดเสียง',
  adWatch: 'ดูโฆษณาให้จบ',
  adCancel: 'ไว้ทีหลัง',
  rankSuffix: '',
  earnedPoints: 'ได้รับ {score} แต้ม',
  helpGoalTitle: '🎯 เป้าหมาย',
  helpGoalText: 'วางตัวหมากบนกระดานขนาด 9x9 และขยายอาณาเขตที่เชื่อมต่อกัน ใครที่มีคะแนนสูงกว่าจะเป็นผู้ชนะ',
  helpWinTitle: '🏆 เงื่อนไขการชนะ',
  helpWinFive: 'วางหมากให้เรียงกัน 5 ตัวในแนวตั้ง แนวนอน หรือแนวทแยงเพื่อชนะทันที',
  helpWinScore: 'หากหมากเต็มกระดาน ผู้ที่มีคะแนนสูงกว่าจะเป็นผู้ชนะ ไม่มีการเสมอ',
  helpScoreTitle: '💯 การคิดคะแนน',
  helpLineBonus: 'โบนัสการเรียง: รับคะแนนเมื่อเรียงหมากได้ 3, 4 และ 5 ตัว',
  helpClusterBonus: 'โบนัสอาณาเขต: คะแนนจะสูงขึ้นตามขนาดของกลุ่มหมากที่เชื่อมต่อกัน',
  helpKomi: 'โคมิ: ผู้เล่นคนที่สองจะได้รับคะแนนพิเศษ +10% เพื่อความสมดุล',
  helpControlsTitle: '🖱️ วิธีการควบคุม',
  helpControlsText: 'ในตาของคุณ ให้แตะที่ช่องว่างเพื่อวางหมาก',
  helpTipsTitle: '💡 คำแนะนำ',
  helpTipHell: 'ลองเล่นโหมด HELL เมื่อคุณต้องการความท้าทายขั้นสูงสุด',
  helpTipCluster: 'อย่าเน้นแค่การเรียง 5 ตัวเท่านั้น การสร้างกลุ่มหมากขนาดใหญ่ก็ช่วยเพิ่มคะแนนได้มาก',
  resultWinFive: '🎉 เรียงครบ 5 ตัว! คุณชนะแล้ว!',
  resultWinScore: '🎉 ชนะด้วยคะแนน! คุณเป็นฝ่ายชนะ!',
  resultLoseFive: '😿 CPU เรียงครบ 5 ตัวแล้ว!',
  resultLoseScore: '😿 แพ้คะแนน พยายามใหม่อีกครั้ง!',
  resultDraw: '🤝 เสมอ',
  newHighscore: '🏆 สถิติใหม่!',
  scoreNone: 'ไม่มีคะแนน',
  clusterBonus: 'โบนัสอาณาเขต',
  retry: 'เล่นอีกครั้ง',
  titleBack: 'หน้าแรก',
  scoreHintPlaceStone: 'วางหมาก',
  best: 'ดีที่สุด',
  clusterUnit: 'กลุ่ม',
  lineCount: 'เรียง {len} ตัว x{count}',
  turnCount: 'ตาที่ {count} · {difficulty}',
  boardPlayerPiece: 'หมากของคุณ',
  boardCpuPiece: 'หมากของ CPU',
  boardPlayerAlt: 'คุณ',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'แถว {row}, คอลัมน์ {col}',
  boardPlaceable: 'วางได้',
  boardEmpty: 'ช่องว่าง',
  boardFlower: 'มีดอกไม้',
  firstPlayerAlt: 'ผู้เล่นคนแรก',
  playerFirst: 'คุณได้เริ่มก่อน!',
  playerSecond: 'คุณได้เริ่มทีหลัง (ได้รับโคมิ +{bonus}%)',
  cpuFirst: 'CPU ได้เริ่มก่อน!',
  finalePlayerWin: 'คุณชนะ!',
  finaleCpuWin: 'CPU ชนะ!',
  finaleFive: 'เรียงครบ 5 ตัว!',
  finaleTerritory: 'ศึกชิงอาณาเขต!',
  winnerAlt: 'ผู้ชนะ',
  loadingBoot: 'กำลังเริ่มเกม...',
  loadingConnect: 'กำลังเชื่อมต่อ...',
  loadingProfile: 'กำลังโหลดโปรไฟล์...',
  loadingAssets: 'กำลังโหลดข้อมูล...',
  loadingReady: 'พร้อมแล้ว',
  reauthRequiredTitle: 'กรุณาเข้าสู่ระบบใหม่',
  startupFailedTitle: 'เริ่มเกมไม่สำเร็จ',
  reauthButton: 'เข้าสู่ระบบอีกครั้ง',
  reloadButton: 'โหลดใหม่',
  lineReloginButton: 'เข้าสู่ระบบ LINE',
  reauthReason: 'การเข้าสู่ระบบของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
  errorReauth: 'การเข้าสู่ระบบของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
  errorForbidden: 'คุณไม่มีสิทธิ์เข้าใช้งานเกมนี้',
  errorNotFound: 'ไม่พบข้อมูลเกม',
  errorRateLimited: 'เครือข่ายหนาแน่น กรุณารอสักครู่แล้วลองใหม่',
  errorServer: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ กรุณารอสักครู่แล้วโหลดใหม่',
  errorCommunication: 'เกิดข้อผิดพลาดในการสื่อสาร กรุณาโหลดใหม่',
  errorNetwork: 'ไม่สามารถเชื่อมต่อเครือข่ายได้ กรุณาตรวจสอบการเชื่อมต่อแล้วโหลดใหม่',
  errorStartup: 'เริ่มเกมไม่สำเร็จ กรุณาโหลดใหม่',
  settingsTabGeneral: 'ตั้งค่า',
  settingsTabAccount: 'บัญชี',
  settingsTabInfo: 'ข้อมูล',
  account: 'บัญชี',
  linked: 'เชื่อมต่อแล้ว',
  guest: 'ผู้มาเยือน',
  loggedInWith: 'เข้าสู่ระบบด้วย {provider}',
  loggedIn: 'เข้าสู่ระบบแล้ว',
  playingAsGuest: 'คุณกำลังเล่นในฐานะผู้มาเยือน',
  appleLoginBusy: 'กำลังเข้าสู่ระบบด้วย Apple...',
  appleLogin: 'เข้าสู่ระบบด้วย Apple',
  googleLoginBusy: 'กำลังเข้าสู่ระบบด้วย Google...',
  googleLogin: 'เข้าสู่ระบบด้วย Google',
  logoutBusy: 'กำลังออกจากระบบ...',
  logout: 'ออกจากระบบ',
  logoutSuccess: 'ออกจากระบบสำเร็จ',
  logoutFailed: 'ออกจากระบบไม่สำเร็จ',
  appInfo: 'ข้อมูลแอป',
  appName: 'ชื่อแอป',
  version: 'เวอร์ชัน',
  legalInfo: 'ข้อมูลทางกฎหมาย',
  terms: 'ข้อกำหนดการใช้งาน',
  privacy: 'นโยบายความเป็นส่วนตัว',
  operator: 'ผู้ดำเนินการ',
  contact: 'ติดต่อเรา',
  copyTap: 'แตะเพื่อคัดลอก',
  idCopied: 'คัดลอก ID แล้ว',
  copyFailed: 'คัดลอกไม่สำเร็จ',
  other: 'อื่นๆ',
  reportAd: 'รายงานโฆษณาที่ไม่เหมาะสม',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'แก้ไขโปรไฟล์',
  displayName: 'ชื่อที่แสดง',
  displayNamePlaceholder: 'กรอกชื่อ',
  chooseIcon: 'เลือกไอคอน',
  iconLoadFailed: 'โหลดรายการไอคอนไม่สำเร็จ',
  saveFailed: 'บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
  noIcons: 'ไม่มีไอคอนให้เลือก',
  save: 'บันทึก',
  saving: 'กำลังบันทึก...',
  staminaAria: 'สตามินา {stamina} / {max}',
  nextRecovery: 'ฟื้นฟูครั้งถัดไปใน {time}',
  adPlaying: 'กำลังเล่นโฆษณา...',
  recoverFullAd: 'ดูโฆษณาเพื่อฟื้นฟูสตามินาเต็ม',
  dailyBonusAria: 'ดูโฆษณาให้จบเพื่อรับสตามินา +5',
  dailyBonusAd: 'ดูโฆษณาเพื่อรับสตามินา +5',
  legalLastUpdated: 'แก้ไขล่าสุดเมื่อ: {date}',
  privacyTitle: 'นโยบายความเป็นส่วนตัว',
  termsTitle: 'ข้อกำหนดการใช้งาน',
  adPlayingAria: 'กำลังเล่นโฆษณา',
  adBadge: '▶ โฆษณา',
  adRemaining: 'เหลืออีก {seconds} วินาที',
  adDevHint: 'โฆษณาทดสอบ หากเป็นเวอร์ชันจริงจะเล่นวิดีโอจาก AdMob',
  adRewardRequirement: 'ดูโฆษณาให้จบเพื่อรับรางวัลนี้',
  adRewardStaminaDetail: 'รางวัล: ฟื้นฟูสตามินาจนเต็ม',
  adRewardDailyBonusDetail: 'รางวัล: สตามินา +{amount} เป็นโบนัสประจำวัน',
  adRewardIncompleteNote: 'ถ้าปิดก่อนจบ จะไม่ได้รับรางวัล',
  adSkipAria: 'ข้ามโฆษณา',
  adSkip: 'ข้าม ✕',
  adSkipAfter: 'ข้ามได้ใน {seconds} วินาที',
  offlineMessage: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ ฟีเจอร์บางอย่างอาจใช้งานไม่ได้',
  reconnecting: 'กำลังเชื่อมต่อใหม่...',
  reconnect: 'เชื่อมต่อใหม่',
  signInTitle: 'ลงชื่อเข้าใช้',
  signInBusy: 'กำลังลงชื่อเข้าใช้...',
  signInCancelNote: 'หากคุณยกเลิก คุณสามารถเล่นต่อในฐานะผู้มาเยือนได้ (ฟีเจอร์บางอย่างจะจำกัดการใช้งาน)',
  processing: 'กำลังประมวลผล...',
  recoverConfirmTitle: 'ยืนยันการเขียนทับข้อมูล',
  recoverConfirmMessage: 'มีข้อมูลเดิมที่เชื่อมต่อกับบัญชีนี้อยู่แล้ว การดำเนินการต่อจะเขียนทับข้อมูลผู้มาเยือนในเครื่องนี้ คุณต้องการดำเนินการต่อหรือไม่?',
  recoverConfirmContinue: 'กู้คืนข้อมูล',
  recoverConfirmCancel: 'ยกเลิก',
  unlinkConfirmTitle: 'ยกเลิกการเชื่อมต่อบัญชี',
  unlinkConfirmMessage: 'หากยกเลิกการเชื่อมต่อ อุปกรณ์นี้จะกลับเข้าสู่โหมดผู้มาเยือน ข้อมูลบน Hub จะยังคงอยู่หากคุณเข้าสู่ระบบด้วยบัญชีเดิมบนอุปกรณ์อื่น',
  unlinkConfirmContinue: 'ยกเลิกการเชื่อมต่อ',
  unlinkConfirmCancel: 'ยกเลิก',
  deleteConfirmTitle: 'ยืนยันการลบบัญชี',
  deleteConfirmMessage: 'การลบบัญชีจะทำให้คะแนนสูงสุด ข้อมูลการเข้าสู่ระบบ บัญชีที่เชื่อมต่อ และการเชิญเพื่อนหายไปทั้งหมด\nการดำเนินการนี้ไม่สามารถย้อนกลับได้ คุณแน่ใจหรือไม่ว่าต้องการลบ?',
  deleteConfirmContinue: 'ลบบัญชี',
  deleteConfirmCancel: 'ยกเลิก',
  adNekoTitle: 'น้องแมวโฆษณา',
  matchmakingRemaining: 'เหลืออีก {seconds} วินาที',
  matchmakingTimeoutMessage: 'หาคู่แข่งไม่เจอในเวลาที่กำหนด กรุณาลองใหม่อีกครั้ง',
  difficultyEasyName: 'ระดับง่าย',
  difficultyEasyDescription: 'คู่แข่งดูเหมือนจะใจลอยเล็กน้อย',
  difficultyNormalName: 'ระดับปกติ',
  difficultyNormalDescription: 'คู่แข่งอาจมีข้อผิดพลาดบ้างในบางครั้ง',
  difficultyHardName: 'ระดับยาก',
  difficultyHardDescription: 'คู่แข่งมีสายตาที่กว้างไกล',
  difficultyHellName: 'ระดับนรก',
  difficultyHellDescription: 'คู่แข่งแข็งแกร่งมากและอ่านเกมขาด',
}
